import { sentryQabConfig } from '@agria/utils/src/sentryConfig';
import * as Sentry from '@sentry/gatsby';

Sentry.init(sentryQabConfig);
